function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoManydesigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 50 300 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ball-left"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.795,36.849C100.225,36.849 94.897,31.523 94.897,24.949C94.897,18.377 100.225,13.051 106.795,13.051C113.368,13.051 118.695,18.377 118.695,24.949C118.695,31.523 113.368,36.849 106.795,36.849M106.795,8.001C97.437,8.001 89.849,15.589 89.849,24.949C89.849,34.311 97.437,41.899 106.795,41.899C116.157,41.899 123.747,34.311 123.747,24.949C123.747,15.589 116.157,8.001 106.795,8.001",
    style: {
      fill: "rgb(0,109,171)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3,24.737C99.3,26.802 100.144,28.685 101.499,30.031C102.858,31.401 104.73,32.233 106.806,32.233C108.875,32.233 110.751,31.401 112.108,30.031C113.461,28.676 114.297,26.802 114.297,24.737C114.297,22.663 113.461,20.792 112.108,19.433L112.108,19.428C110.751,18.076 108.875,17.238 106.806,17.238C104.73,17.238 102.849,18.076 101.499,19.428C100.144,20.792 99.3,22.659 99.3,24.737",
    style: {
      fill: "rgb(96,195,225)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ball-center"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.856,37.119C142.282,37.119 136.955,31.792 136.955,25.22C136.955,18.649 142.282,13.32 148.856,13.32C155.427,13.32 160.752,18.649 160.752,25.22C160.752,31.792 155.427,37.119 148.856,37.119M148.856,8.27C139.493,8.27 131.906,15.858 131.906,25.22C131.906,34.581 139.493,42.168 148.856,42.168C158.216,42.168 165.803,34.581 165.803,25.22C165.803,15.858 158.216,8.27 148.856,8.27",
    style: {
      fill: "rgb(0,109,171)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.357,25.221C141.357,27.286 142.197,29.169 143.556,30.515C144.911,31.885 146.783,32.718 148.859,32.718C150.93,32.718 152.809,31.885 154.164,30.515C155.516,29.16 156.354,27.286 156.354,25.221C156.354,23.149 155.516,21.275 154.164,19.916L154.164,19.912C152.809,18.559 150.93,17.721 148.859,17.721C146.783,17.721 144.909,18.559 143.556,19.912C142.197,21.275 141.357,23.143 141.357,25.221",
    style: {
      fill: "rgb(0,80,144)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ball-right"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.569,36.97C183.995,36.97 178.669,31.643 178.669,25.07C178.669,18.498 183.995,13.171 190.569,13.171C197.136,13.171 202.466,18.498 202.466,25.07C202.466,31.643 197.136,36.97 190.569,36.97M190.569,8.122C181.207,8.122 173.617,15.709 173.617,25.07C173.617,34.432 181.207,42.02 190.569,42.02C199.925,42.02 207.513,34.432 207.513,25.07C207.513,15.709 199.925,8.122 190.569,8.122",
    style: {
      fill: "rgb(0,109,171)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.54964,0,0,2.54964,-229.083,86.0434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.477,25.073C183.477,27.138 184.317,29.02 185.677,30.366C187.031,31.737 188.907,32.568 190.981,32.568C193.053,32.568 194.927,31.737 196.286,30.366C197.636,29.012 198.474,27.138 198.474,25.073C198.474,22.999 197.636,21.127 196.286,19.768L196.286,19.764C194.927,18.411 193.053,17.573 190.981,17.573C188.907,17.573 187.029,18.411 185.677,19.764C184.317,21.127 183.477,22.994 183.477,25.073",
    style: {
      fill: "rgb(28,135,142)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoManydesigns);
export default __webpack_public_path__ + "static/media/logo-manydesigns.ccc8fe79e192bb28f60423f8d1ac60ac.svg";
export { ForwardRef as ReactComponent };